import { render, staticRenderFns } from "./videoDoctor.vue?vue&type=template&id=5de7f47d&scoped=true"
import script from "./videoDoctor.vue?vue&type=script&lang=js"
export * from "./videoDoctor.vue?vue&type=script&lang=js"
import style0 from "./videoDoctor.vue?vue&type=style&index=0&id=5de7f47d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7f47d",
  null
  
)

export default component.exports